import { OPEN_ZOOM } from '../types'

export const openZoom = ({ product }) => {
    return {
        type: OPEN_ZOOM,
        product,
    }
}
